const Config = {
  facebookPageId: "1927657040832873",
  facebookAppId: "265049417495731",
  identityPoolId: "eu-central-1:6c1bf450-cfad-4cdb-aa01-20bf80b9bd1a",
  region: "eu-central-1",
  userPoolId: "eu-central-1_ZRmQQzc4G",
  userPoolWebClientId: "3mfgm6umr59uhtna7b1n7o54ad",
  graphql_endpoint: "https://v2.api.gets.by/graphql",
  // api_stack_key: "11c80608d0495769a9c724197dc801ff",
};

export default Config;
